import { render, staticRenderFns } from "./ResponsiveNavLink.vue?vue&type=template&id=98113224"
import script from "./ResponsiveNavLink.vue?vue&type=script&lang=js"
export * from "./ResponsiveNavLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports